import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const CustomSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      showContent: true,
      tagline: "Elevate Your Business with ETL Services",
      title: "Grow Your Business Potential with Expert Technology Solutions",
      description: "In today's digital landscape, your success relies on innovative and efficient technology strategies. Expert Vision Technology is here to transform your business operations and drive growth!",
      primaryCTA: "Get Started Today",
      primaryCTALink: "/contact-us",
      secondaryCTA: "Explore Services",
      secondaryCTALink: "/services",
      bgImage: "/contact_bg.webp",
    },
    {
      showContent: false,
      bgImage: "/Home2.jpeg",
    },
    {
      showContent: false,
      bgImage: "/Home3.jpeg",
    },
  ];

  // Custom Arrow Components
  const PrevArrow = ({ onClick }) => (
    <button
      onClick={onClick}
      className="absolute top-1/2 left-4 transform -translate-y-1/2 p-3 z-20 rounded-full flex items-center justify-center"
    >
      <svg width="40" height="40" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.3">
          <path
            d="M1.33868 15C1.33868 23.0653 7.87228 29.6031 15.9313 29.6031C23.9903 29.6031 30.524 23.0653 30.524 15C30.524 6.9347 23.9903 0.396945 15.9313 0.396945C7.87228 0.396945 1.33868 6.9347 1.33868 15Z"
            fill="#0D1923"
            stroke="white"
            strokeWidth="0.79389"
          />
          <g clipPath="url(#clip0_308_8993)">
            <path d="M8.39191 14.152H25.2998V15.8481H8.39191V14.152Z" fill="white" />
            <path
              d="M14.4703 21.8751L15.6079 20.6426L9.61877 15.0001L15.6079 9.3576L14.4703 8.12508L7.18742 15.0001L14.4703 21.8751Z"
              fill="white"
            />
          </g>
        </g>
      </svg>
    </button>
  );

  const NextArrow = ({ onClick }) => (
    <button
      onClick={onClick}
      className="absolute top-1/2 right-4 transform -translate-y-1/2 p-3 z-20 rounded-full flex items-center justify-center"
    >
      <svg width="40" height="40" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.3">
          <path
            d="M29.6618 15C29.6618 6.9347 23.1282 0.396946 15.0692 0.396946C7.01014 0.396946 0.476535 6.9347 0.476535 15C0.476535 23.0653 7.01014 29.6031 15.0692 29.6031C23.1282 29.6031 29.6618 23.0653 29.6618 15Z"
            fill="#0D1923"
            stroke="white"
            strokeWidth="0.79389"
          />
          <g clipPath="url(#clip0_308_8980)">
            <path d="M22.6086 15.848L5.70068 15.848V14.1519L22.6086 14.1519V15.848Z" fill="white" />
            <path
              d="M16.5302 8.12492L15.3926 9.35745L21.3817 14.9999L15.3926 20.6424L16.5302 21.8749L23.8131 14.9999L16.5302 8.12492Z"
              fill="white"
            />
          </g>
        </g>
      </svg>
    </button>
  );

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    beforeChange: (current, next) => setCurrentSlide(next),
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: false,
          arrows: false
        }
      }
    ]
  };

  return (
    <div className="relative h-screen w-full overflow-hidden">
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <div key={index} className="relative h-screen">
            {/* Background Image - full display for all slides */}
            <div 
              className="absolute inset-0 bg-no-repeat bg-cover bg-center"
              style={{ backgroundImage: `url(${slide.bgImage})` }}
            >
              {/* Gradient Overlay - only on first slide */}
              {slide.showContent && (
                <div className="absolute inset-0 bg-gradient-to-r from-[#3e2723]/70 to-transparent"></div>
              )}
            </div>
            
            {/* Content - only on first slide */}
            {slide.showContent && (
              <div className="absolute inset-0 flex items-center">
                <div className="container mx-auto px-4 md:px-8 lg:px-16">
                  <div className="max-w-2xl">
                    <span className="inline-flex items-center bg-[#b87268] text-white px-3 py-1 rounded-full text-sm font-medium">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                      </svg>
                      {slide.tagline}
                    </span>
                    <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mt-4 leading-tight">
                      {slide.title}
                    </h1>
                    <p className="text-white/90 text-lg mt-6 mb-8">
                      {slide.description}
                    </p>
                    <div className="flex flex-wrap gap-4">
                      <Link
                        to={slide.primaryCTALink}
                        className="bg-[#8d6e63] font-semibold duration-200 hover:bg-[#a1887f] text-white px-8 py-4 rounded-full shadow-lg"
                      >
                        {slide.primaryCTA}
                      </Link>
                      <Link
                        to={slide.secondaryCTALink}
                        className="bg-white/20 backdrop-blur-sm font-semibold duration-200 hover:bg-white/30 border border-white/50 text-white px-8 py-4 rounded-full"
                      >
                        {slide.secondaryCTA}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}
      </Slider>
      
      {/* Custom dots */}
      <div className="absolute bottom-8 left-0 right-0 flex justify-center gap-2 z-10">
        {slides.map((_, index) => (
          <button 
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full ${currentSlide === index ? 'bg-white' : 'bg-white bg-opacity-30'}`}
          />
        ))}
      </div>
    </div>
  );
};

export default CustomSlider;